import login from './login';

export default {
  language: 'uk-UA',
  country: 'ua',
  name: 'Українська',
  embeddedLocale: login,
};
